import { Injectable } from '@angular/core'
import * as signalR from '@microsoft/signalr'
import { ApiConfiguration } from '../../api/api-configuration'
import { BehaviorSubject, Observable } from 'rxjs'
import { CareFinitySession } from './CareFinitySession'

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  private hubConnection: signalR.HubConnection
  private messageSubject: BehaviorSubject<Message>
  private _server = ''
  public message$: Observable<Message>
  constructor(private config: ApiConfiguration) {
    this.messageSubject = new BehaviorSubject<Message>(new Message())
    this.message$ = this.messageSubject.asObservable()
  }
  public startConnection(server: string) {
    this._server = server
    this.startConnectionInternal()
  }
  public stop() {
    this._server = ''
    this.hubConnection.stop()
  }
  private startConnectionInternal() {
    const token = CareFinitySession.token
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.config.rootUrl + '/' + this._server, {
        accessTokenFactory: () => token!,
      })
      .withAutomaticReconnect()
      .build()

    this.hubConnection
      .start()
      .then(() => console.log('Connection started'))
      .catch((err) => console.log('Error while starting connection: ' + err))

    this.hubConnection.on('Message', (messsage: Message) => {
      this.messageSubject.next(messsage)
    })

    this.addReconnectHandlers()
  }

  private addReconnectHandlers() {
    this.hubConnection.onreconnecting((error) => {
      if (this._server) {
        console.log(`Connection lost due to error "${error}". Reconnecting...`)
      }
    })

    this.hubConnection.onreconnected((connectionId) => {
      console.log(
        `Connection reestablished. Connected with connectionId "${connectionId}".`,
      )
    })

    this.hubConnection.onclose((error) => {
      if (this._server) {
        console.log(
          `Connection closed due to error "${error}". Trying to reconnect...`,
        )
        setTimeout(() => this.startConnectionInternal(), 5000) // Retry after 5 seconds
      }
    })
  }
}
export enum MessageType {
  None,
  EndSession,
}
export class Message {
  type = MessageType.None
  payload: any
}
